import { createFileRoute } from '@tanstack/react-router';
import { CompanyPageById } from '../../features/directory';

export const Route = createFileRoute('/portal/directory/$orgId')({
  component: function CompanyRoute() {
    const { orgId } = Route.useParams();
    return <CompanyPageById orgId={orgId} />;
  },
});
